import { Grid } from "@mui/material";
import { ProductCard, Toast } from "components/ui";
import React from "react";
import { useLocation } from "react-router-dom";

function Product({ product, allData }) {
  return (
    <Grid item className="product">
      <ProductCard data={product} style={{ maxWidth: "474px" }} allData={allData} />
    </Grid>
  );
}

export default Product;
